import React, { Component } from "react";
import {
  Card,
  CardDeck,
  Col,
  Row,
  Container,
  Button,
  Jumbotron,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { jumbotron_bg, calendar, dollar, contract } from "../../images";

import history from "../../history";

class ReportsDefaultView extends Component {
  state = {
    items: [
      {
        img: calendar,
        name: "Daily Report",
        path: "/pawnshop-reports/daily-reports",
        summary: "View summary of daily reports by Cluster and Area",
      },
      {
        img: dollar,
        name: "Gross Income Breakdown",
        path: "/pawnshop-reports/profit-breakdown",
        summary: "View gross income breakdown by Cluster and Area",
      },
      {
        img: contract,
        name: "Inventory Details",
        path: "/pawnshop-reports/inventory-details",
        summary: "View detailed inventory by Cluster and Area",
      },
    ],
  };

  render() {
    return (
      <Container className="mb-5" fluid>
        <Row>
          <Col>
            <Jumbotron
              className="text-light shadow"
              style={{
                backgroundImage: `url(${jumbotron_bg})`,
              }}
            >
              <h1>Pawnshop Reports</h1>
              <p>Please select the report you want to view</p>
            </Jumbotron>
          </Col>
        </Row>
        <Row>
          <Col>
            <CardDeck className="align-content-start justify-content-center">
              {this.state.items.map((item, key) => {
                return (
                  <Card key={key}
                    onClick={() => history.push(item.path)}
                    className="border-0 shadow custom_card"
                  >
                    <Card.Body>
                      <Card.Img variant="top" src={item.img} />
                      <Card.Title>{item.name}</Card.Title>
                      <Card.Subtitle className="text-black-50">
                        {item.summary}
                      </Card.Subtitle>
                      <Link className="float-right mt-2" to={item.path}>
                        <Button variant="primary" size="md">
                          View Report
                        </Button>
                      </Link>
                    </Card.Body>
                  </Card>
                );
              })}
            </CardDeck>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ReportsDefaultView;
